import './LogoSpinner.scss';

import React from 'react';
import PropTypes from 'prop-types';
import { isWhitelabel } from 'src/utils/utils';

export default function LogoSpinner (props) {
  const {
    size,
    thickness
  } = props;


  const whitelabel = isWhitelabel();

  return whitelabel ?
    (
      <svg data-testid='whitelabel-spinner' width={size/3} height={size/3} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z" opacity=".25"/><circle cx="12" cy="2.5" r="1.5"><animateTransform attributeName="transform" type="rotate" dur="0.75s" values="0 12 12;360 12 12" repeatCount="indefinite"/></circle></svg>
    ) : (
      <svg data-testid='spinner' className='st-logo spinner' xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink' viewBox='0 0 355.4 154.78' shapeRendering='geometricPrecision' width={size}>
        <g className='st-logo-container'>
          <path className='st-logo-bg-line' d='M61.34726,149.72L10.557396,149.72L67.93,80.39L86.41,95.12L154.88,7.74L254.09,116.49L273.14,108.41L312.789967,149.72L103.58,149.72L163.88,73.88L182.28,92.3L239.79,27.29L351.7,149.72' fill='none' fillRule='evenodd' stroke='#ccc' strokeWidth={thickness} strokeMiterlimit={thickness} />
          <path className='st-logo-line' d='M61.34726,149.72L10.557396,149.72L67.93,80.39L86.41,95.12L154.88,7.74L254.09,116.49L273.14,108.41L312.789967,149.72L103.58,149.72L163.88,73.88L182.28,92.3L239.79,27.29L351.7,149.72' fill='none' fillRule='evenodd' stroke='#000' strokeWidth={thickness} strokeMiterlimit={thickness} strokeDashoffset='1085.38' strokeDasharray='1085.38' />
        </g>
      </svg>
    );
}

LogoSpinner.propTypes = {
  size: PropTypes.number.isRequired,
  thickness: PropTypes.number
};

LogoSpinner.defaultProps = {
  thickness: 8
};
